import { useEffect, useState } from "react"
import "./home.css"
import { Link } from "react-router-dom";

export default function Home(){
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    const testimonial = [
        {
            profile:"../images/testimonials/user-1.png",
            name:"Pavan Raj",
            testify:"We went on a trip to Phuket exploring the full moon party and Floating YONA party..i would definitely say nobody would have organised our trip so perfectly!!"
        },{
            profile:"../images/testimonials/user-5.png",
            name:"Logeshwari",
            testify:"Exceptional Passport Renewal Service!"
        },{
            profile:"../images/testimonials/user-2.png",
            name:"Vimal P",
            testify:"All under one roof for your travel requirements from Tickets , Flights , Trains , Hotels , and they also do tour packages and give best price for Money Exchange also."
        },{
            profile:"../images/testimonials/user-3.png",
            name:"Mothi Raj",
            testify:"Wonderful Customer Care and Updates from the Travel wise Concern. I strongly recommend to journey with travel wise."
        },{
            profile:"../images/testimonials/user-6.png",
            name:"Lakshmi Harshitha",
            testify:"Travel wise is just amazing. They offer the best price and beats the prices of popular travel services like MakeMyTrip."
        },{
            profile:"../images/testimonials/user-1.png",
            name:"Gautham",
            testify:"Best travel agent in town. The dedication towards the customer satisfaction is to the core. Very polite and express service."
        },
    ]

//  FAQ
    const faqA = [
        {
            title:"What services does Travel Wise offer?",
            content:"Travel Wise provides comprehensive travel planning services, including personalized itineraries, flight and hotel bookings, guided tours, travel insurance, and exclusive experiences for all kinds of travelers."
        },{
            title:"Can Travel Wise help me plan a multi-destination trip?",
            content:"Absolutely! We specialize in designing multi-destination itineraries that ensure your travels are smooth and unforgettable."
        },{
            title:"Does Travel Wise offer group travel packages?",
            content:"Yes, we offer tailored group travel packages for families, friends, and corporate groups, with special discounts and customized experiences for each group."
        },
    ]
    const [faqAOpen, setFaqAOpen] = useState(0)

//  FAQ- B
    const faqB = [
        {
            title:"Is travel insurance included in Travel Wise packages?",
            content:"Travel insurance is available as an add-on to any of our packages, offering protection against trip cancellations, medical emergencies, and lost luggage."
        },{
            title:"Can I modify my Travel Wise itinerary after booking?",
            content:"Yes! We understand that plans can change. Travel Wise provides flexibility and works with you to adjust your itinerary based on your needs, subject to availability and terms."
        },{
            title:"When should I book my trip with Travel Wise?",
            content:"For the best rates and availability, it’s recommended to book early, especially for peak travel seasons. However, Travel Wise also accommodates last-minute bookings depending on availability."
        },
    ]
    const [faqBOpen, setFaqBOpen] = useState(2)

// Form
    const [enqData, setEnqData] = useState({
        name:"",
        mobile:"",
        mail:""
    })
    const onChangeInput = (e) =>{
        const {name, value} = e.target;
        setEnqData((preData)=>({
            ...preData,
            [name]:value
        }))
    } 
    const onSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        formData.append("access_key", process.env.REACT_APP_FORM_KEY);

        const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
        });

        const data = await response.json();
        // console.log(data)
        if (data.success) {
            alert("Thank you Our Team Will Contact You Soon...");
            event.target.reset();
            setEnqData({
                name:"",
                mobile:"",
                mail:""
            })
        } else {
            //   console.log("Error", data);
            alert("Something Went Wrong. Feel Free To Call Us...")
            setEnqData({
                name:"",
                mobile:"",
                mail:""
            })
        }
    };

    return(
        <>
        <div className="wrapper">
            <section className="container homeLanding">
                <main>
                    <h2><span>Welcome to Travel&nbsp;Wise:</span><br/> Your Premier Travel Agency for Unforgettable Journeys</h2>
                    <p>Prepare to embark on the <b>adventure of a lifetime with Travel&nbsp;Wise</b>, your trusted travel partner. We specialize in crafting personalized luxury travel experiences that turn your dream vacations into lasting memories.</p>
                    <aside>
                        <Link to={"/contact"} className="btn mainBtn">Order Now</Link>
                        <Link to={"/about"} className="btn subBtn">About</Link>
                    </aside>
                </main>
                <figure>
                    <img src="../images/homeLanding.webp" alt="Travel&nbsp;Wise"/>
                </figure>
            </section>
        </div>
        <section className="wrapper container topDestination">
            <header>
                <p>Explore the World with Travel&nbsp;Wise:</p>
                <h2>The Adventure Begins:<br/>Where Will Your Next Journey Take You?</h2>
            </header>
            <main>
                <figure>
                    <img src="../images/destinations/dubai.webp" alt="Dubai"/>
                    <div/>
                    <p>Dubai<span>.</span></p>
                </figure>

                <figure>
                    <img src="../images/destinations/london.webp" alt="London"/>
                    <div/>
                    <p>London<span>.</span></p>
                </figure>

                <figure>
                    <img src="../images/destinations/Rome.webp" alt="Rome"/>
                    <div/>
                    <p>Rome<span>.</span></p>
                </figure>

                <figure>
                    <img src="../images/destinations/Spain.webp" alt="Spain"/>
                    <div/>
                    <p>Spain<span>.</span></p>
                </figure>

                <figure>
                    <img src="../images/destinations/Swiss.webp" alt="Swiss"/>
                    <div/>
                    <p>Swiss<span>.</span></p>
                </figure>

                <figure>
                    <img src="../images/destinations/Thailand.webp" alt="Thailand"/>
                    <div/>
                    <p>Thailand<span>.</span></p>
                </figure>
            </main>
            <aside style={{width:"100%", display:"flex", justifyContent:"center", margin:"1rem 0"}}>
                <Link to={"/destination"} className="btn mainBtn">More Destinations ...</Link>
            </aside>
        </section>
        <section className="wrapper container reach1Destination">
            <form className="form" onSubmit={onSubmit}>
                <div className="inputContainer">
                    <label>Name</label>
                    <input 
                        type="text"
                        name="name"
                        value={enqData.name}
                        onChange={onChangeInput}
                        required/>
                </div>
                <div className="inputContainer">
                    <label>Mobile</label>
                    <input 
                        type="text"
                        name="mobile"
                        value={enqData.mobile}
                        onChange={onChangeInput}
                        required/>
                </div>
                <div className="inputContainer">
                    <label>Email</label>
                    <input 
                        type="email"
                        name="mail"
                        value={enqData.mail}
                        onChange={onChangeInput}
                        required/>
                </div>
                <div className="submitContainer">
                    <input type="submit" value={"Submit"}/>
                </div>
            </form>
            <main>
                <h4><span>Special Offer: 25% OFF*</span> Book Now and Save Big!</h4>
                <h3>Travel in Style with Travel&nbsp;Wise:<br/>Tailored Travel Planning Just for You</h3>
                <p>At Travel&nbsp;Wise, we don’t just plan trips; we create exceptional journeys that leave a lasting impact. Whether it’s a relaxing beach holiday or an adventurous tour, our bespoke services ensure every detail is meticulously crafted to suit your style and preferences.</p>
            </main>
        </section>
        <section className="wrapper container stepbystep">
            <main>
                <h4>Step By Step</h4>
                <h3>Travel The World, Your Ultimate Travel Guide with Travel&nbsp;Wise</h3>
                <aside>
                    <details>
                        <summary>
                            <h5><span>1</span> Personalized Travel Consultation</h5>
                            <img src="../images/step.svg" alt="->"/>
                        </summary>
                        <p>Your journey begins with a one-on-one consultation with our expert travel planners. We take the time to understand your preferences, interests, and travel dreams to design a custom-tailored itinerary that fits your ideal destinations, budget, and special requests.</p>
                    </details>

                    <details>
                        <summary>
                            <h5><span>2</span> Customized Itinerary Creation</h5>
                            <img src="../images/step.svg" alt="->"/>
                        </summary>
                        <p>Based on your consultation, our team creates a bespoke itinerary, carefully selecting luxury accommodations, exquisite dining options, exclusive tours, and exciting activities, all designed to give you the ultimate travel experience.</p>
                    </details>

                    <details>
                        <summary>
                            <h5><span>3</span> Hassle-Free Travel Execution and 24/7 Support</h5>
                            <img src="../images/step.svg" alt="->"/>
                        </summary>
                        <p>Once your trip is planned, we manage all logistics to ensure your journey is seamless and stress-free. From booking to confirmations, we provide comprehensive travel documents and 24/7 support to handle any needs or changes during your trip.</p>
                    </details>
                </aside>
            </main>
            <figure>
                <img src="../images/step.webp" alt="Travel&nbsp;Wise"/>
            </figure>
        </section>
        <section className="wrapper container benefits">
            <h4>Why Choose Travel&nbsp;Wise?</h4>
            <h2>Unforgettable Adventures and Lasting Memories</h2>
            <main>
                <aside>
                    <figure>
                        <img src="../images/package.webp" alt="packages"/>
                    </figure>
                    <h3>All-Inclusive Packages</h3>
                    <p>Experience hassle-free vacations with Travel&nbsp;Wise’s all-inclusive packages, covering everything.</p>
                </aside>

                <aside>
                    <figure>
                        <img src="../images/insurance.webp" alt="packages"/>
                    </figure>
                    <h3>Comprehensive Insurance</h3>
                    <p>Travel with peace of mind knowing that we offer comprehensive travel insurance options.</p>
                </aside>

                <aside>
                    <figure>
                        <img src="../images/perks.webp" alt="packages"/>
                    </figure>
                    <h3>Perks & VIP Benefits</h3>
                    <p>As a Travel&nbsp;Wise customer, enjoy VIP treatment, including priority boarding, complimentary upgrades</p>
                </aside>
            </main>
        </section>
        <section className="wrapper parallax"/>
        <section className="wrapper container testimonial">
            <h4>Testimonials</h4>
            <h2>Travel The World, Live Your Dream</h2>
            <main>
                <div className="slideContaienr">
                    <div className="slider" style={{width:`${testimonial.length * 350}px`}}>
                        {testimonial.map((test, key)=>(
                            <aside className="slide" key={key}>
                                <figure>
                                    <img src={test.profile} alt="packages"/>
                                </figure>
                                <h3>{test.name}</h3>
                                <p>{test.testify}</p>
                            </aside>
                        ))}
                    </div>
                </div>
                {/* <figure className="mover moverLeft">
                    <img src="../images/left.svg" alt="<-"/>        
                </figure>
                <figure className="mover moverRight">
                    <img src="../images/right.svg" alt="->"/>
                </figure> */}
            </main>
        </section>
        {/* <section className="wrapper container offer">
            <main>
                <div className="bg">
                    <img src="../images/offer.webp" alt="offer"/>
                </div>
                <div className="offerTag">
                    <img src="../images/bolt.svg" alt="#"/>
                    <p>Summer 2025</p>
                </div>
                <p>Promo</p>
                <h3>Enjoy Summer Deals: 40% OFF</h3>
                <button>
                    <img src="../images/callWhite.svg" alt="C"/>
                    999 999 9999 
                </button>
            </main>
            <form className="form offerForm">
                <p>Get A Discount</p>
                <div className="inputContainer">
                    <label>Name</label>
                    <input type="text"/>
                </div>
                <div className="inputContainer">
                    <label>Mobile</label>
                    <input type="text"/>
                </div>
                <div className="inputContainer">
                    <label>Email</label>
                    <input type="text"/>
                </div>
                <div className="submitContainer">
                    <input type="submit" value={"Submit"}/>
                </div>
            </form>
        </section> */}
        <section className="wrapper container FAQ">
            <p className="subTitle">FAQ</p>
            <h2>Frequently Asked Questions at Travel&nbsp;Wise</h2>
            <main>
                <div>
                    {faqA.map((item,key)=>(
                        <details 
                            key={key} 
                            open={faqAOpen===key}
                            onClick={(e)=>{
                                e.preventDefault()
                                setFaqAOpen(key)}}
                        >
                            <summary>
                                <h5>{item.title}</h5>
                                {/* <h6>&gt;</h6> */}
                                <h6>^</h6>
                            </summary>
                            <p>{item.content}</p>
                        </details>
                    ))}
                </div>
                <div>
                    {faqB.map((item,key)=>(
                        <details 
                            key={key} 
                            open={faqBOpen===key}
                            onClick={(e)=>{
                                e.preventDefault()
                                setFaqBOpen(key)}}
                        >
                            <summary>
                                <h5>{item.title}</h5>
                                {/* <h6>&gt;</h6> */}
                                <h6>^</h6>
                            </summary>
                            <p>{item.content}</p>
                        </details>
                    ))}
                </div>
            </main>
        </section>
        <section className="wrapper container contact">
            <p className="subTitle">Contact us</p>
            <h2>Travel&nbsp;Wise: Explore the World, Fulfill Your Dreams</h2>
            <main className="line">
                <aside>
                    <figure>
                        <img src="../images/callWhite.svg" alt="call"/>
                    </figure>
                    <div>
                        <p className="title">Phone</p>
                        <a className="detail" href="tel:7357356060">735 735 6060</a>
                        <a className="detail" href="tel:9994377761">999 437 7761</a>
                        {/* <p className="detail">(219) 772-1832</p> */}
                    </div>
                </aside>

                <aside>
                    <figure>
                        <img src="../images/callWhite.svg" alt="call"/>
                    </figure>
                    <div>
                        <p className="title">Email</p>
                        <a className="detail" href="mailto:travelwiseindia@gmail.com">travelwiseindia@gmail.com</a>
                        {/* <a className="detail" href="mailto:supp.tour@example.com">supp.tour@example.com</a> */}
                    </div>
                </aside>

                <aside>
                    <figure>
                        <img src="../images/callWhite.svg" alt="call"/>
                    </figure>
                    <div>
                        <p className="title">Address</p>
                        <p className="detail">No.1/52, Babu Rao Street,</p>
                        <p className="detail">(Near C.M.C Hospital),</p>
                        <p className="detail">Vellore - 632004. Tamil Nadu</p>
                    </div>
                </aside>

                <aside>
                    <figure>
                        <img src="../images/callWhite.svg" alt="call"/>
                    </figure>
                    <div>
                        <p className="title">Working Hours</p>
                        <p className="detail">Mon-Sat 10AM - 8PM </p>
                        <p className="detail">Sunday Holiday</p>
                    </div>
                </aside>
            </main>
            <main>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d36427.51090769812!2d79.11796140122937!3d12.923076013273025!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad39fd89a7e755%3A0xfc21029857dc8421!2sTravel%20wise!5e1!3m2!1sen!2sin!4v1737800094816!5m2!1sen!2sin" 
                    style={{width:"100%",height:"550px",border:0}}
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
            </main>
        </section>
        </>
    )
}